/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OpenInvitation } from './OpenInvitation';
import {
    OpenInvitationFromJSON,
    OpenInvitationFromJSONTyped,
    OpenInvitationToJSON,
    OpenInvitationToJSONTyped,
} from './OpenInvitation';

/**
 * 
 * @export
 * @interface UserInvitationsResponse
 */
export interface UserInvitationsResponse {
    /**
     * 
     * @type {Array<OpenInvitation>}
     * @memberof UserInvitationsResponse
     */
    results: Array<OpenInvitation>;
}

/**
 * Check if a given object implements the UserInvitationsResponse interface.
 */
export function instanceOfUserInvitationsResponse(value: object): value is UserInvitationsResponse {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function UserInvitationsResponseFromJSON(json: any): UserInvitationsResponse {
    return UserInvitationsResponseFromJSONTyped(json, false);
}

export function UserInvitationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserInvitationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(OpenInvitationFromJSON)),
    };
}

  export function UserInvitationsResponseToJSON(json: any): UserInvitationsResponse {
      return UserInvitationsResponseToJSONTyped(json, false);
  }

  export function UserInvitationsResponseToJSONTyped(value?: UserInvitationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': ((value['results'] as Array<any>).map(OpenInvitationToJSON)),
    };
}

